import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { faqs } from '../data';
import SafeIcon from '../common/SafeIcon';

export default function Info() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      exit={{ opacity: 0 }}
      className="pt-32 md:pt-40 px-6 container mx-auto min-h-screen max-w-5xl pb-24"
    >
      <header className="mb-16 md:mb-24 border-b border-graphite/20 pb-12 md:pb-16">
        <motion.h1 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="text-fluid-h1"
        >
          ATELIER <br className="hidden sm:block"/> <span className="text-crimson">SERVICES</span>
        </motion.h1>
      </header>
      
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="lg:col-span-4 flex flex-col gap-12"
        >
          <p className="text-lg md:text-xl text-graphite/80 leading-relaxed">
            ArcLoom is dedicated to transparency, exceptional service, and providing all necessary information for a seamless acquisition process.
          </p>
          
          <div className="p-8 bg-graphite text-bone shadow-2xl">
            <h3 className="text-xs uppercase tracking-widest font-bold mb-6 text-crimson flex items-center gap-2">
              <SafeIcon icon="Mail" className="text-base" /> Contact
            </h3>
            <div className="space-y-3">
              <a href="mailto:concierge@arcloom.com" className="block text-sm hover:text-crimson transition-colors">concierge@arcloom.com</a>
              <a href="tel:+18005550199" className="block text-sm hover:text-crimson transition-colors">+1 (800) 555-0199</a>
            </div>
            <div className="mt-8 pt-6 border-t border-bone/20">
              <p className="text-xs uppercase tracking-widest text-bone/50">Operating Hours</p>
              <p className="text-sm mt-2 text-bone/80">Mon-Fri, 9am - 6pm EST</p>
            </div>
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="lg:col-span-8"
        >
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="border-b border-graphite/20 last:border-0 overflow-hidden">
                <button 
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full py-6 md:py-8 flex justify-between items-center text-left hover:text-crimson transition-colors group"
                >
                  <span className="text-xl md:text-2xl tracking-tight uppercase font-medium pr-8">{faq.question}</span>
                  <span className="text-2xl font-light transform transition-transform duration-300 text-graphite/50 group-hover:text-crimson">
                    {openIndex === index ? '−' : '+'}
                  </span>
                </button>
                <AnimatePresence>
                  {openIndex === index && (
                    <motion.div 
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                    >
                      <p className="pb-8 text-graphite/70 text-base md:text-lg leading-relaxed max-w-2xl">
                        {faq.answer}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
}